export default "__VITE_ASSET__BtLwwrv2__"